<template>
  <div>
    <!-- 预定展位 -->
    <div class="home-reserve-booth">
      <div class="home-reserve-booth-title">
        {{ $t('预定展位请联系') }}
      </div>
      <div class="home-reserve-booth-main">
        <el-row :gutter="20">
          <el-col :xs="12" :sm="12" :md="6" :lg="6" v-for="(item, index) in homeReserveBoothList" :key="index">
            <div style="position: relative;" class="pointer">
              <img :src="language == 'en' ? item.url_en : item.url" />
              <div class="home-reserve-booth-main-title">
                {{ language == 'en' ? item.name_en : item.name }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 底部信息 -->
    <div class="home-footer">
      <div class="home-footer-main">
        <div class="home-footer-main-left">
          <img src="@/assets/home/cn/footer_logo.png" />
        </div>
        <div>
          <template v-if="language == 'en'">
            <img src="@/assets/home/en/qrcode.png" />
          </template>
          <template v-else>
            <img src="@/assets/home/cn/qrcode.png" />
          </template>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import zhibaozhan from '@/assets/home/cn/zhibaozhan.png'
import feiliaozhan from '@/assets/home/cn/feiliaozhan.png'
import nonghuazhan from '@/assets/home/cn/nonghuazhan.png'
import xiandainongyezhan from '@/assets/home/cn/xiandainongyezhan.png'

import zhibaozhan_en from '@/assets/home/en/zhibaozhan.png'
import feiliaozhan_en from '@/assets/home/en/feiliaozhan.png'
import nonghuazhan_en from '@/assets/home/en/nonghuazhan.png'
import xiandainongyezhan_en from '@/assets/home/en/xiandainongyezhan.png'
export default {
    computed: {
      ...mapGetters(['language', 'info', 'isLogin', 'subjectType', 'fromUrl'])
    },
    data() {
      return {
        // 预定展位配置
        homeReserveBoothList: [
          {
            url: zhibaozhan,
            url_en: zhibaozhan_en,
            name: '植保展',
            name_en: 'CropProtection'
          },
          {
            url: feiliaozhan,
            url_en: feiliaozhan_en,
            name: '肥料展',
            name_en: 'FSHOW'
          },
          {
            url: nonghuazhan,
            url_en: nonghuazhan_en,
            name: '农化装备及植保器械展',
            name_en: 'CACE'
          },
          {
            url: xiandainongyezhan,
            url_en: xiandainongyezhan_en,
            name: '现代农业科技展',
            name_en: 'AgTech'
          }
        ],
      }
    }
  }
</script>

<style lang="scss" scoped>
.home-reserve-booth {
  margin-top: 32px;

  .home-reserve-booth-title {
    font-weight: 600;
    font-size: 24px;
    color: #FFFFFF;
    line-height: 24px;
    text-align: center;
    padding: 22px;
    background: linear-gradient(90deg, #00875E 0%, #0068A9 100%);
  }

  .home-reserve-booth-main {
    max-width: 1280px;
    margin: 32px auto;

    img {
      width: 100%;
      margin-bottom: 0px;
    }

    .home-reserve-booth-main-title {
      position: absolute;
      top: 15px;
      right: 0;
      width: 100%;
      text-align: center;
      line-height: 20px;
      font-size: 20px;
      color: #fff;
      font-weight: bold;
    }
  }
}

.home-footer {
  
  width: 100%;
  padding: 27px 0 33px 0;
  background: linear-gradient(90deg, #00875E 0%, #0068A9 100%);

  .home-footer-main {
    max-width: 1280px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
      width: 100%;
    }
  }
}

.home-footer-main-left {
  margin-right: 90px;
}

@media (min-width: 320px) and (max-width: 750px) {
  .home-reserve-booth {
    margin-top: 16px;
    .home-reserve-booth-title {
        font-weight: 600;
        font-size: 12px;
        color: #FFFFFF;
        line-height: 12px;
        text-align: center;
        padding: 10px;
        background: linear-gradient(90deg, #00875E 0%, #0068A9 100%);
      }
    
      .home-reserve-booth-main {
        margin: 16px;
    
        img {
          width: 100%;
          margin-bottom: 16px;
        }
    
        .home-reserve-booth-main-title {
          position: absolute;
          top: 5px;
          right: 0;
          width: 100%;
          text-align: center;
          line-height: 20px;
          font-size: 12px;
          color: #fff;
          font-weight: bold;
        }
      }
  }
    .home-footer {
      width: 100%;
      padding: 27px;
      background: linear-gradient(90deg, #00875E 0%, #0068A9 100%);
      .home-footer-main {
        max-width: auto;
        margin: 0 auto;
        display: block;
        img {
          width: 100%;
        }
      }
    }
  
    .home-footer-main-left {
      margin-right: 0px;
    }
}
</style>